import { Configuration } from "@azure/msal-browser";

export const loginRequest = {
    scopes: ["User.Read"], // Specify the API permissions your app needs
  };

  // The main configuration for MSAL (Microsoft Authentication Library)
export const msalConfig: Configuration = {
    auth: {
      clientId: process.env.REACT_APP_AZURE_CLIENT_ID as string,            // Your Azure AD Application's unique ID
      authority: process.env.REACT_APP_AZURE_AUTHORITY, // Authority URL, typically pointing to your Azure AD tenant
      redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,     // Where the user is redirected after authentication (must be registered in Azure)
    },
  };